<template>
    <component class="content-card-heading" :is="headingComponent" :class="headingClasses">
        {{ heading }}
    </component>
</template>

<script>
export default {
    name: 'ContentCardHeading',
    props: {
        heading: {
            required: false,
            type: String,
            default: null,
        },
        headingColor: {
            required: false,
            type: String,
            default: 'text-gray-900',
        },
        headingComponent: {
            required: false,
            type: String,
            default: 'h1',
        },
        marginBottom: {
            required: false,
            type: String,
            default: 'mb-0',
        },
        truncated: {
            required: false,
            type: [Boolean, Number],
            default: true,
        },
        textCentered: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
    },
    computed: {
        headingClasses() {
            const cls = {};
            cls['text-base font-semibold tracking-tight sm:text-base'] = true;
            cls[this.headingColor] = true;
            cls[this.marginBottom] = true;
            cls['truncate'] = !!this.truncated;
            cls['text-center'] = !!this.textCentered;
            return cls;
        },
    },
};
</script>
